import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';

const GenerateApiKey = Loadable(lazy(() => import('./generarApiKey')));


const routes = [
    {
        path: 'generateApiKey',
        element: <GenerateApiKey  />,
    },
];

export default routes;